import React from "react";
import { withStyles } from "@material-ui/core/styles";
import SearchInput from "./SearchInput";
import { Link } from "react-router-dom";

import { AppBar, Toolbar, MenuItem, Typography, Menu } from "@material-ui/core";

const styles = theme => ({
  menuButton: {
    cursor: "pointer",
    marginRight: theme.spacing(2)
  }
});

function Navbar(props) {
  const { classes } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="absolute">
      <Toolbar className={classes.toolbar}>
        <Typography
          variant="h6"
          color="inherit"
          style={{ flex: 1, textDecoration: "none" }}
          to="/"
          component={Link}
        >
          Quizbowl Stats
        </Typography>
        <Typography
          display="inline"
          className={classes.menuButton}
          aria-controls="records-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          Records
        </Typography>
        <Menu
          id="records-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleClose}
        >
          <MenuItem
            onClick={handleClose}
            component={Link}
            to="/record/individual-game"
          >
            Individual Game
          </MenuItem>
          <MenuItem
            onClick={handleClose}
            component={Link}
            to="/record/individual-tournament"
          >
            Individual Tournament
          </MenuItem>
          <MenuItem
            onClick={handleClose}
            component={Link}
            to="/record/individual-career"
          >
            Individual Career
          </MenuItem>
          <MenuItem
            onClick={handleClose}
            component={Link}
            to="/record/team-game"
          >
            Team Game
          </MenuItem>
          <MenuItem
            onClick={handleClose}
            component={Link}
            to="/record/team-tournament"
          >
            Team Tournament
          </MenuItem>
          <MenuItem onClick={handleClose} component={Link} to="/record/school">
            School
          </MenuItem>
        </Menu>
        <SearchInput></SearchInput>
      </Toolbar>
    </AppBar>
  );
}

export default withStyles(styles)(Navbar);
